import React from "react";
import { Link } from "react-router-dom";
import { Card, Typography, Button, Divider, Row, Col } from "antd";
import { ArrowLeftOutlined, FileTextOutlined, SafetyOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const TermsOfService = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
        padding: "40px 20px",
      }}
    >
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Link to="/register">
            <Button
              type="link"
              icon={<ArrowLeftOutlined />}
              style={{
                color: "white",
                fontSize: "16px",
                marginBottom: "20px",
                padding: 0,
              }}
            >
              Retour à l'inscription
            </Button>
          </Link>
          <Title
            level={1}
            style={{
              color: "white",
              textAlign: "center",
              fontSize: "2.5em",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            <FileTextOutlined style={{ marginRight: "15px" }} />
            Conditions d'Utilisation
          </Title>
          <Text
            style={{
              color: "rgba(255,255,255,0.9)",
              fontSize: "18px",
              display: "block",
            }}
          >
            Dernière mise à jour : Janvier 2024
          </Text>
        </div>

        {/* Contenu principal */}
        <Card
          style={{
            background: "rgba(255, 255, 255, 0.95)",
            borderRadius: "20px",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(10px)",
            border: "none",
          }}
          bodyStyle={{ padding: "50px" }}
        >
          {/* Introduction */}
          <section style={{ marginBottom: "40px" }}>
            <Paragraph style={{ fontSize: "18px", color: "#666", lineHeight: "1.8" }}>
              Bienvenue sur <strong>Nomidya</strong> ! Ces conditions d'utilisation régissent votre accès et
              votre utilisation de notre plateforme d'apprentissage en ligne. En créant un compte et en utilisant
              nos services, vous acceptez d'être lié par ces conditions.
            </Paragraph>
          </section>

          <Divider />

          {/* Sections principales */}
          <Row gutter={[0, 40]}>
            {/* Acceptation des conditions */}
            <Col span={24}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                <SafetyOutlined style={{ fontSize: "24px", color: "#667eea", marginRight: "10px" }} />
                <Title level={2} style={{ color: "#333", margin: 0 }}>
                  1. Acceptation des conditions
                </Title>
              </div>
              
              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                En accédant à Nomidya et en l'utilisant, vous confirmez que vous avez lu, compris et accepté
                d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions,
                vous ne devez pas utiliser notre plateforme.
              </Paragraph>
            </Col>

            {/* Comptes utilisateurs */}
            <Col span={24}>
              <Divider />
              <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                <UserOutlined style={{ fontSize: "24px", color: "#764ba2", marginRight: "10px" }} />
                <Title level={2} style={{ color: "#333", margin: 0 }}>
                  2. Comptes utilisateurs
                </Title>
              </div>
              
              <Title level={4} style={{ color: "#555", marginTop: "20px" }}>
                Création de compte :
              </Title>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li>Vous devez fournir des informations exactes et complètes lors de l'inscription</li>
                <li>Vous êtes responsable de maintenir la confidentialité de votre mot de passe</li>
                <li>Vous devez avoir au moins 13 ans pour créer un compte</li>
                <li>Un seul compte par personne est autorisé</li>
              </ul>

              <Title level={4} style={{ color: "#555", marginTop: "20px" }}>
                Sécurité du compte :
              </Title>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li>Vous êtes entièrement responsable de toute activité sur votre compte</li>
                <li>Vous devez nous notifier immédiatement de toute utilisation non autorisée</li>
                <li>Nous nous réservons le droit de suspendre ou supprimer les comptes en cas d'abus</li>
              </ul>
            </Col>

            {/* Utilisation acceptable */}
            <Col span={24}>
              <Divider />
              <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                <WarningOutlined style={{ fontSize: "24px", color: "#f093fb", marginRight: "10px" }} />
                <Title level={2} style={{ color: "#333", margin: 0 }}>
                  3. Utilisation acceptable
                </Title>
              </div>
              
              <Title level={4} style={{ color: "#555", marginTop: "20px" }}>
                Utilisations autorisées :
              </Title>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li>Accéder aux cours et contenus éducatifs pour votre apprentissage personnel</li>
                <li>Participer aux discussions et forums communautaires</li>
                <li>Télécharger les ressources mises à disposition</li>
                <li>Utiliser les outils d'évaluation et de suivi des progrès</li>
              </ul>

              <Title level={4} style={{ color: "#555", marginTop: "20px" }}>
                Utilisations interdites :
              </Title>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li>Partager vos identifiants de connexion avec des tiers</li>
                <li>Télécharger, copier ou distribuer le contenu sans autorisation</li>
                <li>Utiliser la plateforme à des fins commerciales non autorisées</li>
                <li>Publier du contenu offensant, illégal ou inapproprié</li>
                <li>Tenter de contourner les mesures de sécurité</li>
                <li>Utiliser des robots, scrapers ou autres outils automatisés</li>
              </ul>
            </Col>

            {/* Propriété intellectuelle */}
            <Col span={24}>
              <Divider />
              <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
                4. Propriété intellectuelle
              </Title>
              
              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                Tout le contenu disponible sur Nomidya, incluant mais ne se limitant pas aux textes, graphiques,
                logos, icônes, images, clips audio, téléchargements numériques, compilations de données et
                logiciels, est la propriété de Nomidya ou de ses fournisseurs de contenu et est protégé par
                les lois sur la propriété intellectuelle.
              </Paragraph>

              <Title level={4} style={{ color: "#555", marginTop: "20px" }}>
                Droits d'utilisation :
              </Title>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li>Vous recevez une licence limitée, non-exclusive et non-transférable</li>
                <li>L'utilisation est strictement personnelle et éducative</li>
                <li>Toute reproduction ou distribution nécessite une autorisation écrite</li>
              </ul>
            </Col>

            {/* Services et disponibilité */}
            <Col span={24}>
              <Divider />
              <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
                5. Services et disponibilité
              </Title>
              
              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                Nous nous efforçons de maintenir notre service disponible 24h/24 et 7j/7, mais nous ne
                pouvons garantir une disponibilité ininterrompue. Nous nous réservons le droit de :
              </Paragraph>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li>Effectuer des maintenances programmées ou d'urgence</li>
                <li>Modifier ou interrompre temporairement tout ou partie du service</li>
                <li>Mettre à jour le contenu et les fonctionnalités</li>
                <li>Limiter l'accès en cas de surcharge technique</li>
              </ul>
            </Col>

            {/* Limitation de responsabilité */}
            <Col span={24}>
              <Divider />
              <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
                6. Limitation de responsabilité
              </Title>
              
              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                Nomidya fournit ses services "en l'état" et décline toute garantie explicite ou implicite.
                Nous ne serons pas responsables des dommages directs, indirects, accessoires ou consécutifs
                résultant de l'utilisation ou de l'impossibilité d'utiliser notre service.
              </Paragraph>
            </Col>

            {/* Résiliation */}
            <Col span={24}>
              <Divider />
              <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
                7. Résiliation
              </Title>
              
              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                Vous pouvez supprimer votre compte à tout moment. Nous nous réservons le droit de suspendre
                ou supprimer votre compte en cas de violation de ces conditions d'utilisation.
                En cas de résiliation, votre droit d'accès au service cessera immédiatement.
              </Paragraph>
            </Col>

            {/* Contact */}
            <Col span={24}>
              <Divider />
              <Title level={2} style={{ color: "#333", marginBottom: "20px" }}>
                8. Contact et questions
              </Title>
              
              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter à :
              </Paragraph>
              <ul style={{ color: "#666", fontSize: "16px", lineHeight: "1.6" }}>
                <li><strong>Email :</strong> support@nomidya.com</li>
                <li><strong>Adresse :</strong> Nomidya, Service Juridique</li>
              </ul>

              <Paragraph style={{ color: "#666", fontSize: "16px", lineHeight: "1.6", marginTop: "20px" }}>
                Nous nous réservons le droit de modifier ces conditions d'utilisation à tout moment.
                Les modifications prendront effet dès leur publication sur cette page.
              </Paragraph>
            </Col>
          </Row>

          {/* Footer avec boutons */}
          <Divider />
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <Link to="/register">
              <Button
                type="primary"
                size="large"
                style={{
                  background: "linear-gradient(45deg, #667eea, #764ba2)",
                  border: "none",
                  borderRadius: "10px",
                  height: "50px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                  minWidth: "200px",
                  marginRight: "20px",
                }}
              >
                Retour à l'inscription
              </Button>
            </Link>
            
            <Link to="/privacy-policy">
              <Button
                type="default"
                size="large"
                style={{
                  borderRadius: "10px",
                  height: "50px",
                  fontSize: "16px",
                  minWidth: "200px",
                }}
              >
                Politique de confidentialité
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;